module.exports = __webpack_public_path__ + "static/img/technologybimg2.630d10b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coreValues/technologybimg2.jpg
// module id = V5GP
// module chunks = 2